import {
  Offer,
} from "@assets/types"

export const promotionHasPaymentMethod = (promotion: Offer | undefined) =>
  promotion?.paymentMethod && window.parameters.glob_cardPaymentId.split(',')?.some(id => promotion?.paymentMethod?.split(',').includes(id))